import React from "react";
import { FaArrowLeft } from "react-icons/fa";
import { useNavigate, useParams } from "react-router-dom";
import RegistrationsListView from "../Registrations/RegistrationsListView";
import "../../../css/View/VariantRegistrations.css";

const TripRegistrations = ({ registrations = [] }) => {
  const navigate = useNavigate();
  const { guid: tripGuid } = useParams();

  return (
    <div className="trip-variant-section trip-variant-registrations">
      <RegistrationsListView registrations={registrations} />
    </div>
  );
};

export default TripRegistrations;
